import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const ViewPurchaseDocs = () => {
    const { stockId } = useParams();
    const navigate = useNavigate();
    const [docs, setDocs] = useState([]);
    const [invoice, setInvoice] = useState(null);
    const [carDetails, setCarDetails] = useState({});
    const [error, setError] = useState(null);
    const [userType, setUserType] = useState("");
    const [userFullName, setUserFullName] = useState("");

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    useEffect(() => {
        const fetchPurchaseDocs = async () => {
            try {
                const response = await axios.get(`https://api.saadmotors.com/fetch_purchase_docs.php?stock_id=${stockId}`);
                // console.log('Purchase Docs Response:', response.data);
                if (response.data && response.data.carDetails && Array.isArray(response.data.docs)) {
                    setDocs(response.data.docs.filter(doc => doc.path && doc.status));
                    setInvoice(response.data.invoice);
                    setCarDetails(response.data.carDetails);
                    setError(null);
                } else {
                    console.error('Invalid response format:', response.data);
                    setDocs([]);
                    setInvoice(null);
                    setCarDetails({});
                    setError('Failed to load documents or invoice: Invalid API response');
                }
            } catch (error) {
                console.error('Error fetching purchase documents:', error);
                setDocs([]);
                setInvoice(null);
                setCarDetails({});
                setError('Failed to load documents or invoice: Network or server error');
            }
        };

        fetchPurchaseDocs();
    }, [stockId]);

    const handleBack = () => {
        navigate(-1);
    };

    const handleBulkDownload = async () => {
        try {
            const response = await axios.get(`https://api.saadmotors.com/download_docs_zip.php?stock_id=${stockId}`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `vehicle_${stockId}_docs.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading ZIP:', error);
            alert('Failed to download ZIP file. Please check the console for details.');
        }
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={handleBack} className="btn btn-secondary mr-2">
                        Back to Vehicles
                    </button>
                    <button onClick={handleBulkDownload} className="btn btn-primary">
                        Download All Documents (ZIP)
                    </button>
                </div>

                <div className="mainsection">
                    <h3>
                        Vehicle Documents and Invoice (Stock ID: {stockId})
                        {carDetails.maker && (
                            <span style={{ fontSize: '1rem', color: '#666', marginLeft: '10px' }}>
                                | VIN: {carDetails.vin} | {carDetails.maker} {carDetails.model}
                            </span>
                        )}
                    </h3>
                </div>

                <div className="container">
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}

                    {/* Documents Section */}
                    <h4>Documents</h4>
                    {docs.length > 0 ? (
                        <div className="row">
                            {docs.map((doc, index) => (
                                doc.path ? (
                                    <div key={index} className="col-md-4 mb-4">
                                        <div className="card text-center">
                                            <div className="card-body">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="100"
                                                    height="100"
                                                    fill="currentColor"
                                                    className="bi bi-file-pdf text-danger"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/>
                                                </svg>
                                                <p className="card-text mt-2">Document {index + 1} (Status: {doc.status})</p>
                                                <button
                                                    className="btn btn-success btn-sm w-100 mt-2"
                                                    onClick={() => {
                                                        window.open(`https://api.saadmotors.com/${doc.path}`, '_blank');
                                                    }}
                                                >
                                                    View Document
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            ))}
                        </div>
                    ) : (
                        <p className="text-center">No documents available for this vehicle.</p>
                    )}

                    {/* Separator */}
                    <hr style={{ margin: '2rem 0', borderTop: '2px solid #ccc' }} />

                    {/* Invoice Section */}
                    <h4>Invoice</h4>
                    {invoice ? (
                        <div className="row">
                            <div className="col-md-4 mb-4">
                                <div className="card text-center">
                                    <div className="card-body">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="100"
                                            height="100"
                                            fill="currentColor"
                                            className="bi bi-file-text text-primary"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"/>
                                            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                                        </svg>
                                        <p className="card-text mt-2">Invoice</p>
                                        <button
                                            className="btn btn-success btn-sm w-100 mt-2"
                                            onClick={() => {
                                                window.open(`https://api.saadmotors.com/${invoice}`, '_blank');
                                            }}
                                        >
                                            View Invoice
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p className="text-center">No invoice available for this vehicle.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewPurchaseDocs;